import React, { useEffect, useState } from "react";
import { NoneBorderCard } from "../../../components/NoneBorderCard";
import "../style/home-page-style.css";

export const BannerSection = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsActive(true);
    }, 5000);
  }, []);

  return (
    <section className="lg:text-left h-screen relative flex flex-col lg:flex-row w-screen lg:items-center bg-[rgb(4,20,55)] overflow-hidden">
      {/* Background image — full cover on desktop, top portion on mobile */}
      <img
        src="/banner-bg.svg"
        alt=""
        className={`animate-pulse-plnify ${
          isActive && "keep"
        } absolute top-0 left-0 w-full h-full object-contain lg:object-cover object-top z-0`}
      />

      {/* Mobile: spacer that pushes content to bottom half */}
      <div className="flex-1 lg:hidden" />

      {/* Content */}
      <div className="relative z-10 w-full lg:max-w-[1440px] flex-1 lg:flex-none flex items-center justify-center lg:justify-start">
        <NoneBorderCard
          title="Power your event management experience!"
          titleClass={
            "section-title text-center lg:text-left lg:w-[70%] xl:w-full animate__animated animate__fadeInLeft [font-family:'Montserrat',Helvetica] font-bold text-white tracking-[0] leading-[normal]"
          }
          description={
            <p className="section-text text-center lg:text-left lg:w-[85%] xl:w-full text-white">
              Simplify your workflow with an efficient, flexible, and
              easy-to-use event management platform that centralizes
              collaboration and streamlines productivity.
            </p>
          }
          descriptionClass={
            "animate__animated animate__fadeInLeft animate__delay-1s relative self-stretch [font-family:'Montserrat',Helvetica] font-normal text-white tracking-[0] leading-[31px]"
          }
          buttonTitle="Find Your Plans"
          btnTitleClass={
            "button-text text-white [font-family:'Poppins',Helvetica] font-semibold"
          }
          btnClass={`mx-auto lg:mx-0 w-[60%] custom-btn primary text-center ${
            isActive
              ? ""
              : "animate__animated animate__fadeInLeft animate__delay-2s"
          }`}
          sectionClass={
            "w-full px-[10%] lg:px-0 lg:mx-[12%] lg:mt-[3%] gap-[32px] lg:gap-[45px] flex flex-col items-center lg:items-start lg:w-[425px] lg:justify-center pb-16 lg:pb-0 -mt-20 lg:mt-0"
          }
          path={"/plans"}
        />
      </div>
    </section>
  );
};
